import { EventEmitter, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import Pusher from 'pusher-js';
import { Globals } from 'src/app/globals';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
@Injectable({
  providedIn: 'root'
})
export class PusherService {
  public commentBoxPusher = new EventEmitter();
  public commentBox: Subscription;
  pusher: any;
  channel: any;
  /** Channel for inbox events (inbox.read_updated, inbox.new_activity) to refresh unread count. */
  inboxChannel: any;
  code: any;
  // eslint-disable-next-line no-empty-function
  constructor(private http: HttpClient, public globals: Globals, public _rout: Router) {}
  // pusher active
  public pusherGetActive(): void {
    this.pusher = new Pusher(environment.pusher.key, {
      cluster: environment.pusher.cluster,
    });
    if (this.globals.projectCode === "beheer") {
      this.code = this._rout.url.split("/")[2];
    } else {
      this.code = this.globals.projectCode;
    }
    this.channel = this.pusher.subscribe(this.code);
  }

  /**
   * Subscribe to inbox channel (inbox-{projectCode}) and bind events so the sidebar can refresh unread count.
   * Call after pusherGetActive(). Callback is invoked on inbox.read_updated and inbox.new_activity.
   */
  public bindInboxUnreadRefresh(callback: () => void): void {
    if (!this.code || !this.pusher) {
      return;
    }
    if (!this.inboxChannel) {
      this.inboxChannel = this.pusher.subscribe("inbox-" + this.code);
    }
    this.inboxChannel.bind("inbox.read_updated", callback);
    this.inboxChannel.bind("inbox.new_activity", callback);
  }

  //on change any status call the collaboration api
  onCangeStatus(): void {
    this.commentBoxPusher.emit();
  }
}
